import { useTranslation } from 'react-i18next';
import { IconMapLocation } from '@components/icons/icon-map-location';

import { MAGIC_SEARCH_VENUE_COMPANIES_SHOWN } from '../constants';
import { MagicSearchVenueGroupProps } from '../magic-search-palette.type';

import { MagicSearchItemMedia } from './magic-search-item-media';
import { MagicSearchItemText } from './magic-search-item-text';
import { MagicSearchVenueCompanyItem } from './magic-search-venue-company-item';

export const MagicSearchVenueGroup = ({ venue, onOpen }: MagicSearchVenueGroupProps) => {
  const { t } = useTranslation();
  const hiddenCount = venue.companies.length - MAGIC_SEARCH_VENUE_COMPANIES_SHOWN;

  return (
    <div className='py-0.5' data-testid={`magic-search--venue-${venue.id}`}>
      <div className='flex items-center gap-3 px-3 py-2'>
        <MagicSearchItemMedia Icon={IconMapLocation} />
        <MagicSearchItemText title={venue.name} legacyId={venue.legacyId} lines={[[venue.cityName]]} />
      </div>
      <div className='ml-7.5 border-l border-extra-soft pl-1.5'>
        {venue.companies.slice(0, MAGIC_SEARCH_VENUE_COMPANIES_SHOWN).map((company) => (
          <MagicSearchVenueCompanyItem key={company.id} venue={venue} company={company} onOpen={onOpen} />
        ))}
        {hiddenCount > 0 && (
          <p className='px-3 py-1.5 text-body-xs text-tertiary' data-testid='magic-search-venue--more-companies'>
            {t('menu:magicSearchMoreCompanies', { count: hiddenCount })}
          </p>
        )}
      </div>
    </div>
  );
};
